import { Module } from "vuex";
import { RootState } from "../types";
import { TimeLineInt } from "./types";
import { getters } from "./getter";
import { actions } from "./actions";
import { mutations } from "./mutations";

const state = {
  error: "",
  data: [],
} as TimeLineInt;

export const timeLine: Module<TimeLineInt, RootState> = {
  state,
  getters,
  actions,
  mutations,
};
